import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonProjectVariableOverview, CommonProjectVariableTopics } from "../../CommonComponents/CommonProjectVariableViews";

export const ProjectVariableTemplatesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().variables.projectTemplates,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectVariableOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectVariableTopics />;
    }
};
